"use strict";
exports.__esModule = true;
exports.Script = exports.Chat = exports.Button = exports.Features = void 0;
var tslib_1 = require("tslib");
var Button_1 = tslib_1.__importDefault(require("./components/Button"));
exports.Button = Button_1["default"];
var Chat_1 = tslib_1.__importDefault(require("./components/Chat"));
exports.Chat = Chat_1["default"];
var Script_1 = tslib_1.__importDefault(require("./components/Script"));
exports.Script = Script_1["default"];
var Features;
(function (Features) {
    Features["LOGIN_BUTTON"] = "loginButton";
    Features["CHAT_PLUGIN"] = "chatPlugin";
})(Features || (Features = {}));
exports.Features = Features;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tusken-s/facebook-tools/dist/cjs/index.js
// module id = 22
// module chunks = 168707334958949